export const LOAD_ITEMS = 'KYC/LOAD_ITEMS';
export const SET_LOADING = 'KYC/SET_LOADING';